import { gap, paddingY, typography } from "../../../../styles";
import Input, { InputElement } from "../../../Input/Input";
import { add } from "date-fns";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { today } from "../../../../../utils";
import { MonthYearControlsProps } from "../MonthYearControls";
export type YearSelectorProps = Omit<MonthYearControlsProps, "toggleOpen">;
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: center;
  ${gap.s}
`;
const MonthDisplay = styled.div`
  ${typography.body};
`;
const Dropdown = styled(Input).attrs({
  variant: "dropdown"
})<{
  rtl?: boolean;
}>`
  ${paddingY.zero}
  max-width: 5.5rem;
  background-position: ${({
  rtl
}) => rtl ? "10%" : "90%"};
`;
export function YearSelector({
  monthOffset,
  onChange: onChangeOffset
}: YearSelectorProps) {
  const {
    i18n
  } = useTranslation();
  const locale = i18n.language;
  const currentMonth = add(today, {
    months: monthOffset
  });
  const monthDisplay = currentMonth.toLocaleString(locale, {
    month: "long"
  });
  const currentYear = currentMonth.getFullYear();
  const yearOptions = [...Array(200).keys()].map(n => {
    const startYear = today.getFullYear();
    const year = startYear + n;
    const yearDisplay = new Date(year, 0, 1).toLocaleString(locale, {
      year: "numeric"
    });
    return {
      optionId: year.toString(),
      value: yearDisplay
    };
  });
  const onChange = (event: React.ChangeEvent<InputElement>) => {
    const selectedYear = event.target.value;
    const newYear = parseInt(selectedYear);
    const newOffset = monthOffset + (newYear - currentYear) * 12;
    onChangeOffset(newOffset);
  };
  return <Container data-sentry-element="Container" data-sentry-component="YearSelector" data-sentry-source-file="YearSelector.tsx">
      <MonthDisplay data-sentry-element="MonthDisplay" data-sentry-source-file="YearSelector.tsx">{monthDisplay}</MonthDisplay>
      <Dropdown onChange={onChange} options={yearOptions} required rtl={i18n.dir() === "rtl"} value={currentYear} data-sentry-element="Dropdown" data-sentry-source-file="YearSelector.tsx" />
    </Container>;
}
export default YearSelector;